import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const NAV_GROUPS = [
  {
    key: 'studio',
    label: 'Studio',
    items: [
      { to: '/crew', label: 'Crew' },
      { to: '/community-impact', label: 'Community Impact' },
    ],
  },
  {
    key: 'work',
    label: 'Work',
    items: [
      { to: '/live-apps', label: 'Live Apps' },
      { to: '/projects', label: 'Projects' },
      { to: '/products', label: 'Pricing' },
    ],
  },
];

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  const handleToggle = () => setMenuOpen((v) => !v);
  const closeAll = () => {
    setMenuOpen(false);
    setOpenDropdown(null);
  };

  const toggleDropdown = (key) =>
    setOpenDropdown((current) => (current === key ? null : key));

  const isItemActive = (to) => location.pathname === to.split('?')[0];
  const isGroupActive = (group) =>
    group.items.some((item) => isItemActive(item.to));

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    closeAll();
  }, [location.pathname]);

  return (
    <nav className="navbar" ref={navRef}>
      <div className="nav-brand">
        <Link to="/" onClick={closeAll}>
          <img src="/LogoSM.png" alt="ShawnyMedia logo" className="nav-brand-logo" />
          <span className="nav-brand-text">ShawnyMedia LLC</span>
        </Link>
      </div>
      <div className={`nav-links${menuOpen ? ' open' : ''}`}>
        {NAV_GROUPS.map((group) => {
          const isOpen = openDropdown === group.key;
          const groupActive = isGroupActive(group);
          return (
            <div
              key={group.key}
              className={`nav-dropdown${isOpen ? ' open' : ''}${groupActive ? ' group-active' : ''}`}
            >
              <button
                type="button"
                className={`nav-dropdown-trigger${groupActive ? ' active' : ''}`}
                aria-expanded={isOpen}
                aria-haspopup="true"
                onClick={() => toggleDropdown(group.key)}
              >
                {group.label}
                <svg
                  className="nav-dropdown-caret"
                  viewBox="0 0 10 6"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M1 1l4 4 4-4"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="nav-dropdown-menu" role="menu">
                {group.items.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    role="menuitem"
                    className={isItemActive(item.to) ? 'active' : ''}
                    onClick={closeAll}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          );
        })}

        <Link
          to="/contact?reason=contact"
          className={location.pathname === '/contact' ? 'active' : ''}
          onClick={closeAll}
        >
          Contact
        </Link>

        {/* Single primary CTA, present on every page. To use an external
            scheduler later, swap this <Link> for an <a href="https://calendly.com/...">. */}
        <Link to="/start" className="nav-cta" onClick={closeAll}>
          Get Started
          <span className="nav-cta-arrow" aria-hidden="true">→</span>
        </Link>
      </div>
      <button
        className={`nav-toggle${menuOpen ? ' is-open' : ''}`}
        onClick={handleToggle}
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
      >
        <span className="hamburger"></span>
        <span className="hamburger"></span>
      </button>
    </nav>
  );
};

export default Navbar;
